import React, { PureComponent } from 'react';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

class FieldsSelect extends PureComponent {
    handleFieldChange = (e) => this.props.handleFieldButtonClick(e.target.value);
    render() {
        const {selectId, selectText, selectOptions, selectColumns} = this.props;
        return (
            <div className={"fieldHolder selectField col-12 col-md-" + selectColumns}>
                <FormControl fullWidth={true}>
                    <InputLabel htmlFor="communicationTypeId">Tipos de Comunicação</InputLabel>
                    <Select id={selectId}
                            value="0"
                            className="smallerSelect"
                            disabled={this.props.disabled}
                            onChange={this.handleFieldChange}>
                        <MenuItem value="0" disabled={true}>{selectText}</MenuItem>
                        {
                            selectOptions.map((option, index) =>
                                <MenuItem key={index} value={"{{"+option.value+"}}"}>{option.text}</MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </div>
        );
    }
}

export default FieldsSelect;
